/** Consumers needing a complete schedule must follow every page, not just page one. */
export async function collectTaskPages<T>(load: (cursor?: string) => Promise<{
  tasks: T[]; page_info: { next_cursor: string | null; has_next_page: boolean };
}>): Promise<T[]> {
  const result: T[] = [];
  const seen = new Set<string>();
  let cursor: string | undefined;
  do {
    const page = await load(cursor);
    result.push(...page.tasks);
    if (!page.page_info.has_next_page) return result;
    const next = page.page_info.next_cursor;
    if (!next || seen.has(next)) throw new Error("Task pagination did not advance. Please retry.");
    seen.add(next);
    cursor = next;
  } while (cursor);
  return result;
}
